import { useEffect } from 'react';

type useAutosizeTextAreaOptions = {
    maxHeight?: number,
    minHeight?: number
}

const useAutosizeTextAreaOptionDefaults: useAutosizeTextAreaOptions = {
    maxHeight: 0,
    minHeight: 0
}

// Updates the height of a <textarea> when the value changes.
// textAreaRef - reference (returned from useRef()) to the textarea
// value - current value of the text area, use to trigger updates
// options - object of options to be used to customize hook
//     maxHeight - the maximum height of the textarea, 0 = no max, 0 is default
//     minHeight - the minimum height of the textarea, 0 = no min, 0 is default
const useAutosizeTextArea = (
    textAreaRef: HTMLTextAreaElement | null,
    value: string,
    options: any = useAutosizeTextAreaOptionDefaults
) => {
    useEffect(() => {
        if (textAreaRef) {
            // We need to reset the height momentarily to get the correct scrollHeight for the textarea
            textAreaRef.style.height = '0px';
            const scrollHeight = textAreaRef.scrollHeight;

            let textareaHeight = scrollHeight;
            if (options.maxHeight > 0 && scrollHeight > options.maxHeight) {
                textareaHeight = options.maxHeight;
            } else if (options.minHeight > 0 && scrollHeight < options.minHeight) {
                textareaHeight = options.minHeight;
            }

            // We then set the height directly, outside of the render loop
            // Trying to set this with state or a ref will product an incorrect value.
            textAreaRef.style.height = textareaHeight + 'px';
        }
    }, [textAreaRef, value]);
};

export default useAutosizeTextArea;